import * as React from 'react';
import { motion } from 'framer-motion';

function SvgDownArrow(props) {
  return (
    <motion.svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 10" {...props}>
      <path
        fill="#fff"
        d="M7.187 8.963a.62.62 0 0 0 .976 0l.469-.583.05-.059.934-1.163 4.72-5.878c.52-.683-.31-1.554-.96-1.009L7.673 5.313 1.972.271a.66.66 0 0 0-.88 0 .74.74 0 0 0-.081 1.01l5.654 7.04.047.055z"
      />
    </motion.svg>
  );
}
export default SvgDownArrow;
